import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import Button from 'components/common/Button';
import { FadeIn } from 'components/common/FadeIn';

import QuestionsAndAnswers from './questions-and-answers';
import styles from './QuickAnswers.module.css';

const QuickAnswers = () => {
  return (
    <div className={clsx('daymadeTypographyReset', styles.questions)}>
      <AboutUsModule background="white" withMorePadding>
        <AboutUsSiteContainer styles2026>
          <div className={styles.introHeading}>
            <FadeIn onScroll>
              <div className={styles.headingContainer}>
                <p className="daymadeTypographyTaglineAccent">
                  You might be wondering...
                </p>
                <h2 className="daymadeTypographyXL">Quick answers</h2>
              </div>
            </FadeIn>
            <FadeIn onScroll delay={0.1} className="desktopOnly">
              <Button href="/faq" buttonStyle="Tertiary" buttonSize="Medium">
                Read More
              </Button>
            </FadeIn>
          </div>
          <div className={styles.mainContent}>
            <QuestionsAndAnswers />
            <FadeIn
              onScroll
              delay={0.1}
              className={clsx(styles.buttonContainer, 'mobileOnly')}
            >
              <Button href="/faq" buttonStyle="Tertiary" buttonSize="Medium">
                Read More
              </Button>
            </FadeIn>
          </div>
        </AboutUsSiteContainer>
      </AboutUsModule>
    </div>
  );
};

export default QuickAnswers;
